import React from "react";
import { Sparkles } from "lucide-react";

const PLAN_STYLES = {
  free:    { label: "Free",    color: "#888888", bg: "#88888818", border: "#88888844" },
  starter: { label: "Starter", color: "#378ADD", bg: "#378ADD18", border: "#378ADD44" },
  pro:     { label: "Pro",     color: "#FF6B00", bg: "#FF6B0018", border: "#FF6B0055" },
  family:  { label: "Family",  color: "#1D9E75", bg: "#1D9E7518", border: "#1D9E7544" },
};

export default function PlanBadge({ plan, trialDaysLeft, cancelled, compact = false }) {
  const key = (plan || "free").toLowerCase();
  const s = PLAN_STYLES[key] || PLAN_STYLES.free;
  const suffix = cancelled
    ? " · Cancelled"
    : typeof trialDaysLeft === "number" && trialDaysLeft > 0
    ? ` · ${trialDaysLeft}d trial`
    : "";
  return (
    <div
      className={`inline-flex items-center gap-1.5 font-bold uppercase tracking-[0.18em] ${
        compact ? "px-2 py-1 text-[10px]" : "px-2.5 py-1 text-[11px]"
      }`}
      style={{ color: s.color, background: s.bg, border: `1px solid ${s.border}` }}
      data-testid={`plan-badge-${key}`}
    >
      {key === "pro" && <Sparkles className="w-3 h-3" />}
      <span>{s.label}{suffix}</span>
    </div>
  );
}
